<template>
    <v-container v-if="value" class="bnft-wishlist-data-grid" :class="$mobile ? 'px-0' : ''">
        <v-row>
            <v-col v-for="item of items" :key="item.gtin" cols="4">
                <v-img height="300" width="300" v-if="!$mobile" lazy-src="https://picsum.photos/id/497/1080/1080" @click="
                                imageOverlays[overlayId(item)] = !imageOverlays[overlayId(item)]
                            " :src="$near.ipfsAdapter(item.media)"></v-img>
                <v-overlay z-index="10" :value="isOverlayOn(item)" @click="
                                imageClickHandler(item)
                            ">
                    <v-img class="rounded-xl" :src="$near.ipfsAdapter(item.media)"></v-img>
                </v-overlay>
            </v-col>
        </v-row>
    </v-container>
</template>
<style>
</style>
<script>
import BN from 'bn.js';
import Vue from 'vue';
import { until } from 'async';
import VueNumber from '@667/vue-number-animation';

Vue.use(VueNumber);

export default {
    name: 'BnftWishlistDataGrid',
    props: {
        value: Object,
    },
    components: {},
    methods: {
        imageClickHandler(item) {
            let { imageOverlays, overlayId } = this;
            imageOverlays[overlayId(item)] = !imageOverlays[overlayId(item)]
        },
        overlayId(item) {
            return `${this.value.id}:${item?.id?.gtin}`;
        },
        isOverlayOn(item) {
            if (this.imageOverlays[this.overlayId(item)] === undefined)
                this.$set(this.imageOverlays, this.overlayId(item), false);
            return (
                this.imageOverlays[this.overlayId(item)] && this.flickerTimeout
            );
        },
        updateBalances(item) {
            if (item.balance) {
                item.usd = this.$near.convertToUSD(
                    this.$near.utils.format.formatNearAmount(
                        new BN(item.balance)
                    )
                );
                item.approximateFundingPercentage = Number(
                    (item.usd / process.env.VUE_APP_APPROXIMATE_NEW_BRA_COST) *
                        100
                ).toFixed(2);
            }
            return item;
        },
    },
    watch: {
        items: {
            deep: true,
            handler(items) {
                items &&
                    items.map((item) => {
                        this.updateBalances(item);
                        //this.$refs.prettyNumber.restart(); // not sure if I like this effect or not...
                    });
            },
        },
    },
    computed: {
        items() {
            return this?.value?.items?.length
                ? this.value.items.map((item) => ({
                      uniqueId: this.$near.uniqueId(
                          this.value.id,
                          this.item?.gtin
                      ),
                      ...item,
                  }))
                : undefined;
        },
        owner() {
            return this.value.owner;
        },
        wallet() {
            return this.$near.wallet[process.env.VUE_APP_NEAR_WISHLIST_CONTRACT_ID]
        },
        isOwner() {
            return (
                this.wallet &&
                this.wallet.isSignedIn() &&
                this.wallet.getAccountId() === this.owner
            );
        },
        media() {
            return this.value?.media?.length ? this.value.media[0] : undefined;
        },
    },
    data: function () {
        return {
            headers: [
                { text: `Images`, value: 'media' },
                { text: `What bra would you like?`, value: 'description' },
                { text: ``, value: 'control' },
            ],
            currency: {
                default: 'usd',
                current: 'usd',
            },
            flickerTimeout: false,
            imageOverlays: {},
        };
    },
    mounted() {
        const self = this;
        setTimeout(() => (this.flickerTimeout = true), 1500);
        (async function () {
            if (!self.$store.state.lastNearListing?.NEAR?.quote?.USD?.price)
                await self.$backend.getLatestNearListing();
        })();

        until(
            function test(cb) {
                cb(null, self.items);
            },
            function iter(next) {
                setTimeout(() => next(), 500);
            },
            function done() {
                self.items.map((item) => {
                    self.updateBalances(item);
                    return item;
                });
            }
        );
    },
};
</script>
